import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferTidalToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.transferTidalToYoutube}
            sections={<PairTransferGuideContent sourceKey="tidal" destKey="youtube" />}
        />
    );
}
